import { IONICWrapper } from "./common";
export const search_module = 'search/results'
export const search_path = '/app/search'
export const capacity_see_result = '/app/manage-capacity/see-results'
export const search_path_results = '/app/search/results'

/**
 * DeadHead display logic for WEB
 * @param props 
 * @param stopDetail 
 * @returns 
 */
export const detectSeachPath = (location:string) => {
    return !!(location && location.includes(capacity_see_result) || location && location.includes(search_path)) 
}

export function checkForDeadHeadWeb(props?: any, stopDetail?: any) {
  return !!(
    (props.origin &&
      props.origin !== "Anywhere" &&
      stopDetail.stopType === "P") ||
    (props.destination &&
      props.destination !== "Anywhere" &&
      stopDetail.stopType === "D")
  );
}
/**
 * DeadHead display logic for Mobile
 * @param props 
 * @param stopDetail 
 * @returns 
 */
 export function checkForDeadHeadMob(params:any,props: any, stopDetail?: any) {
    /** Get Search Params From session storage */
    
    const cProps = params

    return !!(
      (cProps &&
        props &&
        detectSeachPathMobile(props) &&        
        ((cProps.origin && cProps.origin !== "Anywhere" && stopDetail.stopType === "P") ||
          (cProps.destination && cProps.destination !== "Anywhere" &&
            stopDetail.stopType === "D")))
    ); 
}
/**
 * 
 * @param props detect Mobile App path. 
 * @returns true if the navigate from `search` & `search/result` module only
 */
export const detectStopType = (props: any, stopDetail: any) => {
    return !!(
        props.origin !== "Anywhere" &&
        stopDetail.stopType === "P" ||
        props.destination !== "Anywhere" &&
        stopDetail.stopType === "D"
    ) 
}

export const detectSeachPathMobile = (props: any) => {
    return !!(props && props.module === search_module) 
}
/**
 * 
 * @param props Remove storage data
 */
export const removeSearchParams = async(props:any) => {
    (props && props.module !== search_module) && IONICWrapper.details.vault &&
    (await IONICWrapper.details.vault.removeValue(
      'searchParam'
    ));
}
/**
 *
 * @param deadhead stopdetails deadhead value.
 * @returns null if not proper deadhead else integer deadhead value
 */
export const convertDeadheadToInt = (deadhead: any) =>
  deadhead == 0
    ? 0
    : deadhead && !isNaN(deadhead)
    ? Math.round(deadhead)
    : null;
